 <template>
    <router-view />
</template>

<script>
export default {
  name: "AgentesModule"
};
</script>